import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedNeedsAttentionReasons, setSelectedPatientsListType } from '../copilotControlSlice'

export default () => {
  const dispatch = useDispatch()

  const { selectedPatientsListType, selectedNeedsAttentionReasons } = useSelector(state => state.copilotControlReducer)
  const { data: statuses, isLoading: isStatusesLoading } = useSelector(state => state.treatmentReducer.statuses)

  const handlePatientListTypeSelected = useCallback(
    value => {
      dispatch(setSelectedPatientsListType(value))
    },
    [dispatch]
  )

  const handleSelectedNeedsAttentionReasonsUpdated = useCallback(
    value => {
      dispatch(setSelectedNeedsAttentionReasons(value))
    },
    [dispatch]
  )

  const getPatientStatusObject = useCallback(
    (statusKey, program) => statuses[program]?.find(statusItem => statusItem.key === statusKey),
    [statuses]
  )

  return {
    statuses,
    isStatusesLoading,
    selectedPatientsListType,
    selectedNeedsAttentionReasons,
    handlePatientListTypeSelected,
    handleSelectedNeedsAttentionReasonsUpdated,
    getPatientStatusObject
  }
}
